import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { IoArrowBackOutline, IoSearch } from "react-icons/io5";
import apiClient from "../api/apiClient";
import "../css/Charts.css";
import "../css/mainhome.css";

export default function ChartsScreen() {
  const navigate = useNavigate();
  const [query, setQuery] = useState("");

  const [charts, setCharts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCharts = async () => {
      try {
        const response = await apiClient.get("/chart-game-list");

        if (response.data?.status && Array.isArray(response.data.info)) {
          setCharts(response.data.info);
        } else {
          throw new Error(response.data?.msg || "Failed to fetch chart list.");
        }
      } catch (err) {
        console.error("Chart list fetch error:", err);
        setError(err.message || "Failed to load charts.");
      } finally {
        setLoading(false);
      }
    };

    fetchCharts();
  }, []);

  const filteredCharts = charts.filter((chart) =>
    chart.gameName?.toLowerCase().includes(query.toLowerCase())
  );

  const createSlug = (name) =>
    name?.toLowerCase().replace(/\s+/g, "-");

  return (
    <div className="mainhome-screen-wrapper">
      <div className="charts-header">
        <button className="back-btn" onClick={() => navigate(-1)}>
          <IoArrowBackOutline size={24} />
        </button>
        <h2>Charts</h2>
      </div>

      <div className="search-box">
        <IoSearch size={20} className="search-icon" />
        <input
          type="text"
          placeholder="Search chart"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />
      </div>

      <div className="chart-grid screen-content">
        {loading && (
          <p className="chart-message">Loading charts...</p>
        )}

        {!loading && error && (
          <p className="chart-message error">{error}</p>
        )}

        {!loading && !error && filteredCharts.length === 0 && (
          <p className="chart-message">No charts found</p>
        )}

        {!loading &&
          !error &&
          filteredCharts.map((chart) => (
            <button
              key={chart.gameId}
              className="chart-btn"
              onClick={() =>
                navigate(
                  `/charts/${chart.gameId}/${createSlug(chart.gameName)}`
                )
              }
            >
              {chart.gameName}
            </button>
          ))}
      </div>
    </div>
  );
}